import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { threshold: { type: Number, default: 0.3 } };

  connect() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.element.classList.add('is-pre-reveal');

    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.element.classList.add('is-in-view');
          this.observer.disconnect();
          this.observer = null;
          break;
        }
      }
    }, { threshold: this.thresholdValue });
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
